import styles from "./social-account.module.scss";
import { Pencil, Trash2 } from "lucide-react";

interface Props {
  logo: React.ReactNode;
  title: string;
  link: string;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
}

export const SocialAccount = ({
  logo,
  link,
  title,
  onEditClick,
  onDeleteClick,
}: Props) => {
  return (
    <div className={styles.socialAccount}>
      <div className={styles.logo}>{logo}</div>
      <div className={styles.details}>
        <p>{title}</p>
        <p>{link}</p>
      </div>

      <button>
        <Pencil stroke="#5c5c5a" onClick={onEditClick} />
      </button>
      <button>
        <Trash2 stroke="#5c5c5a" onClick={onDeleteClick} />
      </button>
    </div>
  );
};
